import { render, staticRenderFns } from "./Child_routing.vue?vue&type=template&id=599f326d&scoped=true&"
import script from "./Child_routing.vue?vue&type=script&lang=ts&"
export * from "./Child_routing.vue?vue&type=script&lang=ts&"
import style0 from "./Child_routing.vue?vue&type=style&index=0&id=599f326d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f326d",
  null
  
)

export default component.exports